/* Mobau Pro – Zentrallager als 2. Lager im Shopify-Shop (Lead/Dennis 13.10.2026, zuerst nur Test-Shop).
   Quelle dieser Datei: bestand/shopify_zentrallager.js → Theme-Asset assets/mobau-zentrallager.js (1:1 hochladen,
   tests/test_shopify_zentrallager.py prüft Gleichstand mit lieferzeit.py und public_commerce).

   Daten: Der Bestandswächter (Test-Ziel) setzt den Shopify-Bestand am Standort Übach auf
   Übach + sichtbarer Zentrallager-Anteil (2/3, ganze ZL-Gebinde, nur vergleichbare Einheit) und schreibt je Variante
   das Metafeld mobau.zentrallager = {menge, einheit, gebinde, gebinde_bez, gebinde_mehrzahl, anbruch_max, stand,
   nur_vorraetig}. Verkauft wird zuerst aus Übach: zl_jetzt = min(menge, inventory), uebach_jetzt = inventory − zl_jetzt.

   Regeln wie im KI-Chat:
   * Lieferzeit (lieferzeit.py): ZL-Belieferung Di/Do, Bestellung dort 2 Werktage vorher, abholbereit/versandfertig am
     Werktag nach Anlieferung, Werktage ohne NRW-Feiertage, Kundenbestellung ab 12 Uhr zählt ab dem nächsten Werktag.
   * Ganze Gebinde (cart.tsx packMengeErlaubt): bis zum Übach-Bestand jede Menge, darüber nur Mengen, deren
     Fehlmenge ganze ZL-Gebinde füllt (Rest ≤ anbruch_max = Abverkauf von 60 Tagen).
   Keine Preise, kein EK – nur Bestand und Daten. Test: ?mbjetzt=2026-10-17T11:59 setzt die Uhrzeit (nur Anzeige). */
(function () {
  'use strict';
  var TAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var ZL_LIEFERTAGE = [2, 4];          /* Dienstag, Donnerstag (getUTCDay) */
  var ZL_VORLAUF_WERKTAGE = 2;
  var BESTELLSCHLUSS_STUNDE = 12;
  var MAX_ALTER_STUNDEN = 48;
  var feiertagCache = {};

  /* ---------- Kalender (gleiche Regeln wie lieferzeit.py) ---------- */
  function tag(j, mo, t) { return new Date(Date.UTC(j, mo - 1, t)); }
  function plus(d, n) { return new Date(d.getTime() + n * 86400000); }
  function key(d) { return d.toISOString().slice(0, 10); }
  function ostersonntag(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
      t = ((h + l - 7 * m + 114) % 31) + 1;
    return tag(j, mo, t);
  }
  function feiertage(j) {
    if (feiertagCache[j]) return feiertagCache[j];
    var o = ostersonntag(j), s = {};
    [-2, 1, 39, 50, 60].forEach(function (n) { s[key(plus(o, n))] = 1; });               /* Karfreitag … Fronleichnam */
    [[1, 1], [5, 1], [10, 3], [11, 1], [12, 25], [12, 26]].forEach(function (x) { s[key(tag(j, x[0], x[1]))] = 1; });
    return (feiertagCache[j] = s);
  }
  function istWerktag(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !feiertage(d.getUTCFullYear())[key(d)]; }
  function naechsterWerktag(d) { do { d = plus(d, 1); } while (!istWerktag(d)); return d; }
  function plusWerktage(d, n) { for (var i = 0; i < n; i++) d = naechsterWerktag(d); return d; }
  /* jetzt = {j, mo, t, h, mi} in Europe/Berlin */
  function bestelltag(jetzt) {
    var heute = tag(jetzt.j, jetzt.mo, jetzt.t);
    return (!istWerktag(heute) || jetzt.h >= BESTELLSCHLUSS_STUNDE) ? naechsterWerktag(heute) : heute;
  }
  function zlAnlieferung(jetzt) {
    var d = plusWerktage(bestelltag(jetzt), ZL_VORLAUF_WERKTAGE);
    while (ZL_LIEFERTAGE.indexOf(d.getUTCDay()) === -1 || !istWerktag(d)) d = plus(d, 1);
    return d;
  }
  function zlBereit(jetzt) { return naechsterWerktag(zlAnlieferung(jetzt)); }
  function tagText(d) { return TAGE[d.getUTCDay()] + ', ' + ('0' + d.getUTCDate()).slice(-2) + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '.'; }

  /* ---------- Mengen ---------- */
  /* zl = Metafeld mobau.zentrallager (oder null), inv = Shopify-Bestand der Variante, jetztMs = Date.now() */
  function zlMenge(zl, inv, jetztMs) {
    /* nur_vorraetig: ZL zählt in einer anderen Einheit; menge ist dann die vorsichtige Untergrenze in unserer
       Verkaufseinheit (je ZL-Gebinde mindestens eine), die das Zentrallager nach der Bestellung bestätigt. */
    if (!zl || !(zl.menge > 0)) return 0;
    if (zl.stand && jetztMs) {
      var t = Date.parse(zl.stand);
      if (isFinite(t) && jetztMs - t > MAX_ALTER_STUNDEN * 3600000) return 0;  /* alter Stand: nicht mehr zusagen */
    }
    return Math.max(0, Math.min(Math.floor(zl.menge), Math.floor(inv || 0)));
  }
  function aufteilung(zl, inv, jetztMs) {
    var z = zlMenge(zl, inv, jetztMs), i = Math.max(0, Math.floor(inv || 0));
    return { uebach: i - z, zl: z, max: i };
  }
  /* Davon aus dem Zentrallager bei Bestellmenge q */
  function zlTeil(auf, q) { return Math.max(0, Math.min(auf.zl, q - auf.uebach)); }
  function packRegel(zl, auf) {
    var p = zl && Math.floor(zl.gebinde);
    if (!(p > 1) || !(auf.zl > 0)) return null;
    return { uebach: auf.uebach, pack: p, restMax: Math.max(0, Math.floor(zl.anbruch_max) || 0),
      label: zl.gebinde_bez || 'Palette', labelN: zl.gebinde_mehrzahl || zl.gebinde_bez || 'Paletten' };
  }
  function packMengeErlaubt(rule, qty) {
    if (!rule) return true;
    var fehl = qty - Math.max(0, rule.uebach);
    if (fehl <= 0) return true;
    var rest = ((-fehl % rule.pack) + rule.pack) % rule.pack;
    return rest <= rule.restMax;
  }
  function packNaechsteMenge(rule, qty, dir, max) {
    max = max || 99999;
    var next = qty + dir;
    while (next >= 1 && next <= max && !packMengeErlaubt(rule, next)) next += dir;
    if (next < 1) return packMengeErlaubt(rule, 1) ? 1 : packNaechsteMenge(rule, 0, 1, max);
    return Math.min(next, max);
  }
  /* lieber abrunden (nie mehr kaufen als gewollt); nur wenn darunter nichts geht, auf das erste ganze Gebinde */
  function packPassendeMenge(rule, qty, max) {
    max = max || 99999;
    var want = Math.min(Math.max(1, Math.floor(qty)), max);
    if (packMengeErlaubt(rule, want)) return want;
    for (var q = want - 1; q >= 1; q -= 1) if (packMengeErlaubt(rule, q)) return q;
    return packNaechsteMenge(rule, want, 1, max);
  }

  /* 422 von /cart/add.js: „Aufgrund der Verfügbarkeit wurden nur 500 Artikel …“ → 500 (sonst null) */
  function limitAusMeldung(antwort) {
    var m = String((antwort && (antwort.description || antwort.message)) || '').match(/nur\s+([\d.]+)\s+Artikel/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) : null;
  }

  var core = { limitAusMeldung: limitAusMeldung, tag: tag, key: key, feiertage: feiertage, istWerktag: istWerktag, bestelltag: bestelltag,
    zlAnlieferung: zlAnlieferung, zlBereit: zlBereit, tagText: tagText, zlMenge: zlMenge, aufteilung: aufteilung,
    zlTeil: zlTeil, packRegel: packRegel, packMengeErlaubt: packMengeErlaubt, packNaechsteMenge: packNaechsteMenge,
    packPassendeMenge: packPassendeMenge };
  if (typeof module === 'object' && module.exports) { module.exports = core; return; }
  if (window.MobauZL) return;
  window.MobauZL = core;

  /* =================================================================== Browser ============================== */
  function jetztBerlin() {
    var test = null;
    try { test = new URL(location.href).searchParams.get('mbjetzt'); } catch (e) {}
    if (test) {
      var m = test.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
      if (m) return { j: +m[1], mo: +m[2], t: +m[3], h: +m[4], mi: +m[5] };
    }
    var p = {};
    try {
      new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { j: +p.year, mo: +p.month, t: +p.day, h: +p.hour % 24, mi: +p.minute };
    } catch (e) {
      var d = new Date(); return { j: d.getFullYear(), mo: d.getMonth() + 1, t: d.getDate(), h: d.getHours(), mi: d.getMinutes() };
    }
  }
  function bereit() { return zlBereit(jetztBerlin()); }
  core.bereitIso = function () { return key(bereit()); };
  core.bereitText = function () { return tagText(bereit()); };
  function zahl(n) { return Number(n).toLocaleString('de-DE'); }
  function einheit(d, n) { return n === 1 ? (d.e1 || 'Stück') : (d.en || 'Stück'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  (function () {
    try {
      var st = document.createElement('style');
      st.textContent = '.mbzl-liste{display:flex;flex-direction:column;gap:8px;flex:1 1 auto;min-width:0}.mbzl-z{display:flex;gap:8px;align-items:flex-start}' +
        '.mpdp-dot--zl{background:#1f6fb2!important}.mbzl-klein{display:block;font-size:13px;color:#4a5059;margin-top:2px}' +
        '.mbzl-teil{margin:8px 0 0;padding:8px 10px;border-radius:8px;background:#eef5fb;color:#173f63;font-size:14px;line-height:1.4}' +
        '.mbzl-teil[hidden]{display:none}.mbzl-teil--warn{background:#fff4e5;color:#7a3e00}' +
        '.mbzl-cart{margin:10px 0;padding:10px 12px;border-radius:8px;background:#eef5fb;color:#173f63;font-size:14px;line-height:1.45}' +
        '.mbzl-cart p{margin:0}.mbzl-cart p+p{margin-top:6px}.mbzl-cart--warn{background:#fff4e5;color:#7a3e00}' +
        '.mb-dot--zl{background:#1f6fb2!important}.mb-card__zl{display:block;margin-top:3px}.mb-card__zl--allein{margin-top:0}' +
        '.ms-lager.is-zl{color:#1f6fb2}';
      document.head.appendChild(st);
    } catch (e) {}
  })();

  /* ---------- Produktseite ---------- */
  var pdp = null; /* {daten: {vid: {...}}, root} */
  function pdpDaten() {
    if (pdp) return pdp;
    var el = document.querySelector('script[data-mobau-zl]');
    if (!el) return null;
    try { pdp = { daten: JSON.parse(el.textContent) || {}, pid: el.getAttribute('data-mobau-zl') }; } catch (e) { return null; }
    return pdp;
  }
  function variantDaten(vid) { var p = pdpDaten(); return p ? p.daten[String(vid)] : null; }
  function info(vid) {
    var d = variantDaten(vid);
    if (!d || !d.zl) return null;
    var auf = aufteilung(d.zl, d.inv, Date.now());
    return { d: d, auf: auf, rule: packRegel(d.zl, auf), nurVorraetig: !!d.zl.nur_vorraetig };
  }
  /* Ersatz für availHtml der Produktseite (mobau-pdp-script ruft das zuerst auf). null = Standardanzeige. */
  core.availHtml = function (v) {
    if (!v || v.k === 'strecke') return null;
    var x = info(v.id);
    if (!x) return null;
    var d = x.d, auf = x.auf, z = [];
    if (x.nurVorraetig && auf.zl > 0) {
      if (auf.uebach > 0) z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--ok"></span><span><strong>Sofort verfügbar: ' + zahl(auf.uebach) + ' ' + esc(einheit(d, auf.uebach)) + '</strong> im Markt Übach-Palenberg</span></span>');
      z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--zl"></span><span><strong>' + (auf.uebach > 0 ? 'Zusätzlich vorrätig im Zentrallager' : 'Vorrätig in unserem Zentrallager') +
        '</strong> – abholbereit bzw. versandfertig ab <strong>' + core.bereitText() + '</strong>' +
        '<span class="mbzl-klein">Die Menge aus dem Zentrallager bestätigen wir Ihnen nach der Bestellung. Belieferung unseres Marktes dienstags und donnerstags.</span></span></span>');
      return '<span class="mbzl-liste">' + z.join('') + '</span>';
    }
    if (x.nurVorraetig) {
      if (auf.max > 0) z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--ok"></span><span><strong>Sofort verfügbar: ' + zahl(auf.max) + ' ' + esc(einheit(d, auf.max)) + '</strong> im Markt Übach-Palenberg</span></span>');
      else z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--warn"></span><span><strong>In Übach derzeit nicht vorrätig</strong></span></span>');
      z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--zl"></span><span>Weitere Ware in unserem <strong>Zentrallager</strong> vorrätig – ' +
        (auf.max > 0 ? 'größere Mengen' : 'Bestellung') + ' gern auf Anfrage im Markt.</span></span>');
      return '<span class="mbzl-liste">' + z.join('') + '</span>';
    }
    if (!(auf.zl > 0)) return null;
    var ab = core.bereitText();
    if (auf.uebach > 0) {
      z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--ok"></span><span><strong>Sofort verfügbar: ' + zahl(auf.uebach) + ' ' + esc(einheit(d, auf.uebach)) + '</strong> im Markt Übach-Palenberg</span></span>');
      z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--zl"></span><span><strong>Zusätzlich im Zentrallager: ' + zahl(auf.zl) + ' ' + esc(einheit(d, auf.zl)) +
        '</strong> – abholbereit bzw. versandfertig ab <strong>' + ab + '</strong>');
    } else {
      z.push('<span class="mbzl-z"><span class="mpdp-dot mpdp-dot--zl"></span><span><strong>Lieferbar aus unserem Zentrallager: ' + zahl(auf.zl) + ' ' + esc(einheit(d, auf.zl)) +
        '</strong> – abholbereit bzw. versandfertig ab <strong>' + ab + '</strong>');
    }
    if (x.rule) {
      z[z.length - 1] += '<span class="mbzl-klein">' + (auf.uebach > 0 ? 'Mehr als ' + zahl(auf.uebach) + ' ' + esc(einheit(d, auf.uebach)) + ' nur in ganzen ' : 'Nur in ganzen ') +
        esc(x.rule.labelN) + ' (' + zahl(x.rule.pack) + ' ' + esc(einheit(d, x.rule.pack)) + ' je ' + esc(x.rule.label) + ').</span>';
    }
    z[z.length - 1] += '<span class="mbzl-klein">Belieferung unseres Marktes dienstags und donnerstags.</span></span></span>';
    return '<span class="mbzl-liste">' + z.join('') + '</span>';
  };

  /* Shopify „Add to cart limit“ (Einstellungen → Checkout): kappt jede Warenkorbzeile (live 500, Test 50) und meldet
     422 „… nur N Artikel …“. Liegt N unter dem Bestand, ist das die Shopify-Grenze, nicht der Lagerbestand. */
  core.limitText = function (antwort, vid) {
    var n = limitAusMeldung(antwort), d = variantDaten(vid), inv = d ? d.inv : null;
    if (!(n > 0) || (inv !== null && n >= inv)) return null;
    return 'Online sind höchstens ' + zahl(n) + '\u00a0' + esc(d ? einheit(d, n) : 'Stück') + ' je Artikel und Bestellung möglich – diese Menge liegt jetzt in Ihrem Warenkorb. ' +
      'Für größere Mengen (vorrätig: ' + zahl(inv) + ') rufen Sie uns bitte an: 02451 4834-0.';
  };

  function aktuelleVid() { var i = document.querySelector('#AddToCartForm [data-variant-id], [data-variant-id]'); return i ? i.value : null; }
  function qtyInput() { return document.querySelector('#AddToCartForm [data-qty-input]'); }
  function hinweisEl() {
    var h = document.querySelector('[data-mbzl-teil]');
    if (h) return h;
    var anker = document.querySelector('#AddToCartForm [data-pe-total]') || document.querySelector('#AddToCartForm .mpdp-cart');
    if (!anker) return null;
    h = document.createElement('p'); h.className = 'mbzl-teil'; h.setAttribute('data-mbzl-teil', ''); h.setAttribute('aria-live', 'polite'); h.hidden = true;
    anker.parentNode.insertBefore(h, anker.nextSibling);
    return h;
  }
  var angepasst = '', intern = false;
  function pdpAktualisieren() {
    var vid = aktuelleVid(); if (!vid || !pdpDaten()) return;
    var x = info(vid), q = qtyInput(), h = hinweisEl(), lz = document.querySelector('[data-mb-liefer][data-art="produkt"]');
    var n = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var teil = x ? zlTeil(x.auf, n) : 0;
    if (h) {
      var t = '';
      if (teil > 0) t = 'Davon <strong>' + zahl(teil) + ' ' + esc(einheit(x.d, teil)) + ' aus unserem Zentrallager</strong>' + (x.nurVorraetig ? ' (die Menge bestätigen wir nach der Bestellung)' : '') + ' – Ihre Bestellung ist abholbereit bzw. versandfertig ab <strong>' + core.bereitText() + '</strong>';
      if (angepasst) t = angepasst + (t ? '<br>' + t : '');
      h.innerHTML = t; h.hidden = !t; h.classList.toggle('mbzl-teil--warn', !!angepasst);
    }
    if (lz) {
      if (teil > 0) lz.setAttribute('data-zl-ab', core.bereitIso()); else lz.removeAttribute('data-zl-ab');
      if (window.MobauLieferzeit && lz.getAttribute('data-zl-zuletzt') !== String(teil > 0)) { lz.setAttribute('data-zl-zuletzt', String(teil > 0)); window.MobauLieferzeit.zeichnen(lz); }
    }
  }
  function mengeSetzen(q, wert) {
    if (+q.value === wert) return;
    q.value = wert;
    intern = true;
    try { q.dispatchEvent(new Event('input', { bubbles: true })); } finally { intern = false; }
  }
  function packHinweis(x, gewollt, neu) {
    if (gewollt === neu) return '';
    return 'Menge auf ' + zahl(neu) + ' ' + esc(einheit(x.d, neu)) + ' angepasst: Über ' + zahl(x.auf.uebach) + ' ' + esc(einheit(x.d, x.auf.uebach)) +
      ' hinaus liefern wir aus dem Zentrallager nur ganze ' + esc(x.rule.labelN) + ' (' + zahl(x.rule.pack) + ' ' + esc(einheit(x.d, x.rule.pack)) + ' je ' + esc(x.rule.label) + ').';
  }
  /* +/− der Produktseite: bei Gebinderegel springen statt ±1 (vor dem Standard-Handler, der dann nicht läuft) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#AddToCartForm [data-qty-step]');
    if (!b) return;
    var x = info(aktuelleVid()), q = qtyInput();
    if (!x || !x.rule || !q) return;
    e.stopPropagation();
    var cur = Math.max(1, parseInt(q.value, 10) || 1), max = x.auf.max || 99999;
    angepasst = '';
    mengeSetzen(q, packNaechsteMenge(x.rule, cur, +b.getAttribute('data-qty-step') > 0 ? 1 : -1, max));
    pdpAktualisieren();
  }, true);
  document.addEventListener('change', function (e) {
    var q = e.target.closest && e.target.closest('#AddToCartForm [data-qty-input]');
    if (!q) return;
    var x = info(aktuelleVid());
    if (x && x.rule) {
      var want = Math.max(1, parseInt(q.value, 10) || 1), neu = packPassendeMenge(x.rule, want, x.auf.max || 99999);
      angepasst = packHinweis(x, Math.min(want, x.auf.max || want), neu);
      mengeSetzen(q, neu);
    }
    pdpAktualisieren();
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('#AddToCartForm [data-qty-input]')) { if (!intern) angepasst = ''; pdpAktualisieren(); }
  });
  document.addEventListener('variant:changed', function () {
    angepasst = '';
    var x = info(aktuelleVid()), q = qtyInput();
    if (x && x.rule && q) mengeSetzen(q, packPassendeMenge(x.rule, parseInt(q.value, 10) || 1, x.auf.max || 99999));
    var lz = document.querySelector('[data-mb-liefer][data-art="produkt"]'); if (lz) lz.removeAttribute('data-zl-zuletzt');
    pdpAktualisieren();
  });

  /* ---------- Warenkorb (Seite + Mini-Warenkorb) ---------- */
  var ATTR = 'Zentrallager';                    /* Bestell-Attribut für das Lager (alle Teilmengen) */
  var PROP = 'Aus dem Zentrallager';            /* Zeilen-Eigenschaft, sichtbar in Warenkorb, Kasse und Bestellung */
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('mobau-zl-v1') || '{}'); if (cache._t && Date.now() - cache._t > 600000) cache = {}; } catch (e) { cache = {}; }
  function vorschau(url) {
    try { var p = new URLSearchParams(location.search).get('preview_theme_id'); if (p) { var u = new URL(url, location.origin); u.searchParams.set('preview_theme_id', p); return u.pathname + u.search; } } catch (e) {}
    return url;
  }
  function produkt(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(vorschau('/products/' + encodeURIComponent(handle) + '?view=mobau-zl'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '{}'; })
      .then(function (t) { var d = {}; try { d = JSON.parse(t); } catch (e) {} cache[handle] = d; cache._t = cache._t || Date.now();
        try { sessionStorage.setItem('mobau-zl-v1', JSON.stringify(cache)); } catch (e) {} return d; })
      .catch(function () { return {}; });
  }
  var jetztMs = Date.now();
  /* je Zeile: Übach zuerst über alle Zeilen derselben Variante verteilen */
  function auswerten(cart) {
    var items = cart.items || [];
    var handles = {}; items.forEach(function (it) { handles[it.handle] = 1; });
    return Promise.all(Object.keys(handles).map(function (h) { return produkt(h).then(function (d) { return [h, d]; }); })).then(function (paare) {
      var prod = {}; paare.forEach(function (p) { prod[p[0]] = p[1]; });
      var rest = {}, summe = {}, zeilen = [];
      items.forEach(function (it, i) {
        var d = (prod[it.handle] || {})[String(it.variant_id)];
        var x = d && d.zl ? { d: d, auf: aufteilung(d.zl, d.inv, jetztMs) } : null;
        if (x) x.rule = packRegel(d.zl, x.auf);
        var vid = String(it.variant_id);
        if (x && !(vid in rest)) rest[vid] = x.auf.uebach;
        summe[vid] = (summe[vid] || 0) + it.quantity;
        var teil = 0;
        if (x && x.auf.zl > 0) { var aus = Math.min(rest[vid], it.quantity); rest[vid] -= aus; teil = it.quantity - aus; }
        zeilen.push({ it: it, line: i + 1, x: x, teil: teil, vid: vid });
      });
      zeilen.forEach(function (z) { z.summe = summe[z.vid]; });
      return zeilen;
    });
  }
  function propWert(z) {
    if (!(z.teil > 0)) return '';
    return zahl(z.teil) + ' ' + einheit(z.x.d, z.teil) + (z.x.d.zl.nur_vorraetig ? ' – Menge wird vom Zentrallager bestätigt' : '') +
      ' – abholbereit/versandfertig ab ' + core.bereitText();
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Fehler'); return j; }); });
  }
  var meldungen = [], versucht = {};
  var laeuft = false, nochmal = false;
  function synchronisieren() {
    if (!window.fetch) return;
    if (laeuft) { nochmal = true; return; }
    laeuft = true; jetztMs = Date.now();
    var geaendert = false;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      return auswerten(cart).then(function (zeilen) {
        var kette = Promise.resolve();
        /* 1. Gebinderegel: unzulässige Menge der (letzten) Zeile einer Variante korrigieren */
        var gesehen = {};
        zeilen.slice().reverse().forEach(function (z) {
          if (!z.x || !z.x.rule || gesehen[z.vid]) return;
          gesehen[z.vid] = 1;
          if (packMengeErlaubt(z.x.rule, z.summe)) return;
          var andere = z.summe - z.it.quantity;
          var ziel = packPassendeMenge(z.x.rule, z.summe, z.x.auf.max || 99999) - andere;
          if (ziel < 0) ziel = 0;
          meldungen.push(z.it.product_title + ': Menge auf ' + zahl(ziel + andere) + ' ' + einheit(z.x.d, ziel + andere) + ' angepasst – aus dem Zentrallager nur ganze ' +
            z.x.rule.labelN + ' (' + zahl(z.x.rule.pack) + ' ' + einheit(z.x.d, z.x.rule.pack) + ' je ' + z.x.rule.label + ').');
          kette = kette.then(function () { geaendert = true; return post('/cart/change.js', { line: z.line, quantity: ziel }); });
        });
        return kette.then(function () {
          if (!geaendert) return { cart: cart, zeilen: zeilen };
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
            .then(function (c2) { return auswerten(c2).then(function (z2) { return { cart: c2, zeilen: z2 }; }); });
        });
      });
    }).then(function (st) {
      /* 2. Zeilen-Eigenschaft „Aus dem Zentrallager“ setzen/entfernen (Zeilennummern ändern sich dabei nicht) */
      var kette = Promise.resolve();
      st.zeilen.forEach(function (z) {
        var soll = z.x ? propWert(z) : '';
        var ist = (z.it.properties || {})[PROP] || '';
        if (soll === ist) return;
        /* Schleifenschutz: dieselbe Änderung höchstens zweimal je 30 s versuchen */
        var sig = z.it.key + '|' + soll, t = Date.now();
        versucht[sig] = (versucht[sig] || []).filter(function (x) { return t - x < 30000; });
        if (versucht[sig].length >= 2) return;
        versucht[sig].push(t);
        var props = {}; Object.keys(z.it.properties || {}).forEach(function (k) { if (k !== PROP && z.it.properties[k] != null && z.it.properties[k] !== '') props[k] = z.it.properties[k]; });
        props[PROP] = soll;   /* leerer Wert entfernt die Angabe (ein leeres Objekt ließe sie stehen) */
        kette = kette.then(function () { geaendert = true; return post('/cart/change.js', { line: z.line, quantity: z.it.quantity, properties: props }); });
      });
      /* 3. Bestell-Attribut für das Lager: alle Teilmengen mit Artikelnummer */
      var teile = st.zeilen.filter(function (z) { return z.teil > 0; });
      var attr = teile.map(function (z) { return 'Art.-Nr. ' + (z.it.sku || z.vid) + ': ' + zahl(z.teil) + ' ' + einheit(z.x.d, z.teil) + (z.x.d.zl.nur_vorraetig ? ' (Menge vom ZL bestätigen lassen: ZL führt in ' + (z.x.d.zl.zl_einheit || 'anderer Einheit') + ')' : ''); }).join('; ');
      if (attr) attr += ' (beim Zentrallager bestellen, Ware ab ' + core.bereitText() + ')';
      if (((st.cart.attributes || {})[ATTR] || '') !== attr) {
        var a = {}; a[ATTR] = attr;
        kette = kette.then(function () { return post('/cart/update.js', { attributes: a }); });
      }
      return kette.then(function () { return teile; });
    }).then(function (teile) {
      zeichnen(teile);
      if (geaendert) return neuZeichnen();
    }).catch(function () {}).then(function () {
      laeuft = false;
      if (nochmal) { nochmal = false; synchronisieren(); } else regelnLaden();
    });
  }
  function zeichnen(teile) {
    var ab = teile.length ? core.bereitIso() : '';
    document.querySelectorAll('[data-mb-liefer][data-art="warenkorb"], [data-mb-liefer][data-art="mini"]').forEach(function (el) {
      if (ab) el.setAttribute('data-zl-ab', ab); else el.removeAttribute('data-zl-ab');
      if (window.MobauLieferzeit && el.getAttribute('data-klasse')) window.MobauLieferzeit.zeichnen(el);
      var box = el.nextElementSibling && el.nextElementSibling.matches('[data-mbzl-cart]') ? el.nextElementSibling : null;
      var html = '';
      if (meldungen.length) html += meldungen.map(function (m) { return '<p>' + esc(m) + '</p>'; }).join('');
      if (teile.length && el.getAttribute('data-art') === 'warenkorb') {
        html += '<p><strong>Teilmenge aus unserem Zentrallager:</strong> ' + teile.map(function (z) { return esc(z.it.product_title) + ' – ' + zahl(z.teil) + ' ' + esc(einheit(z.x.d, z.teil)); }).join('; ') +
          '.</p><p>Wir bestellen sie für Sie; Belieferung dienstags und donnerstags. Ihre Bestellung ist <strong>abholbereit bzw. versandfertig ab ' + core.bereitText() + '</strong></p>';
      }
      if (!html) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('div'); box.setAttribute('data-mbzl-cart', ''); box.setAttribute('role', 'status'); el.parentNode.insertBefore(box, el.nextSibling); }
      box.className = 'mbzl-cart' + (meldungen.length ? ' mbzl-cart--warn' : '');
      box.innerHTML = html;
    });
  }
  function neuZeichnen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.modern-cart-wrapper').forEach(function (w) { if (w._renderModernCart) w._renderModernCart(cart); });
      var alt = document.querySelector('[data-mb-cart]');
      if (!alt) return;
      return fetch(vorschau('/cart?sections=mobau-warenkorb')).then(function (r) { return r.json(); }).then(function (s) {
        var html = s && s['mobau-warenkorb']; if (!html) return;
        var box = document.createElement('div'); box.innerHTML = html;
        var neu = box.querySelector('[data-mb-cart]'); if (neu && alt.parentNode) alt.replaceWith(neu);
      });
    });
  }
  /* +/− und Eingabe in Warenkorb-Seite und Mini-Warenkorb: bei Gebinderegel auf die nächste zulässige Menge springen.
     Läuft vor den Standard-Handlern (window, Capture) und stellt deren Ausgangswert so, dass ±1 genau dort landet. */
  var regelJeKey = {};
  function regelnLaden() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(auswerten).then(function (zeilen) {
      regelJeKey = {};
      zeilen.forEach(function (z) { if (z.x && z.x.rule) regelJeKey[z.it.key] = { rule: z.x.rule, max: z.x.auf.max, andere: z.summe - z.it.quantity }; });
    }).catch(function () {});
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mb-qty], [data-mc-qty]');
    if (!b) return;
    var row = b.closest('[data-key]'); if (!row) return;
    meldungen = [];
    var r = regelJeKey[row.getAttribute('data-key')]; if (!r) return;
    var dir = parseInt(b.getAttribute(b.hasAttribute('data-mb-qty') ? 'data-mb-qty' : 'data-mc-qty'), 10) > 0 ? 1 : -1;
    var inp = row.querySelector('[data-mb-qty-input]'), nEl = row.querySelector('.mc-qty__n');
    var cur = inp ? parseInt(inp.value, 10) || 0 : parseInt(nEl && nEl.textContent, 10) || 0;
    var ziel = packNaechsteMenge(r.rule, cur + r.andere, dir, r.max) - r.andere;
    if (dir < 0 && cur <= 1) return;               /* Entfernen bleibt Entfernen */
    var start = ziel - dir;
    if (inp) inp.value = start;
    else if (nEl && nEl.firstChild && nEl.firstChild.nodeType === 3) nEl.firstChild.nodeValue = String(start);
  }, true);
  window.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-mb-qty-input]'); if (!inp) return;
    meldungen = [];
    var row = inp.closest('[data-key]'); var r = row && regelJeKey[row.getAttribute('data-key')]; if (!r) return;
    var n = parseInt(inp.value, 10) || 0; if (n <= 0) return;
    inp.value = packPassendeMenge(r.rule, n + r.andere, r.max) - r.andere;
  }, true);

  function cartStart() {
    if (!document.querySelector('[data-mb-liefer][data-art="warenkorb"], [data-mb-liefer][data-art="mini"], [data-mb-cart]')) return;
    synchronisieren();
  }
  document.addEventListener('cart:updated', function () { meldungen = []; setTimeout(synchronisieren, 300); });
  var beob = null;
  function beobachten() {
    var c = document.querySelector('[data-mb-cart]');
    if (!c || !window.MutationObserver) return;
    if (beob) beob.disconnect();
    beob = new MutationObserver(function () { setTimeout(function () { if (!document.contains(c)) {
      beobachten(); synchronisieren();
      /* neu gezeichneter Warenkorb: Lieferzeit-Box neu füllen lassen (mobau-versandzeit.js hört darauf) */
      document.dispatchEvent(new CustomEvent('mobau:cart-rendered'));
    } }, 50); });
    beob.observe(c.parentNode, { childList: true });
  }
  /* Bereitstellungsdatum in Produktkarten/Suche: <span data-mbzl-ab hidden> → „ (ab Fr, 16.10.)“ */
  function daten() {
    var leer = document.querySelectorAll('[data-mbzl-ab][hidden]');
    if (!leer.length) return;
    var t = ' (ab ' + core.bereitText() + ')';
    leer.forEach(function (el) { el.textContent = t; el.hidden = false; });
  }
  core.datenFuellen = daten;
  var datenGeplant = false;
  function datenBeobachten() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () { if (datenGeplant) return; datenGeplant = true; setTimeout(function () { datenGeplant = false; daten(); }, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  function start() { pdpAktualisieren(); cartStart(); beobachten(); daten(); datenBeobachten(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
